import { format } from 'date-fns';
import { DoubleTextElipsisWithTooltip, useObserver, Tooltip } from 'shared-ui';

import { DateFormat } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { truncate } from 'helpers/truncate';
import { Table } from 'ui/table/Table';
import { EventModDescriptionEnum } from '../../Events.enum';
import { EventCategoryDescriptionEnum } from '../InneEvents.enum';

import { InneEventsTableRowProps } from './InneEventsTableRow.types';
import * as Styled from './InneEventsTableRow.styles';

export const InneEventsTableRow = ({ event, displayFullTable }: InneEventsTableRowProps) => {
  const { formatMessage } = useLocale();
  const { tableWidth } = useObserver();
  const ownerFullName = `${event?.posiadacz?.nazwisko || ''} ${event?.posiadacz?.imie || ''}`;

  return (
    <>
      <Table.RowItem>{event.idTkd}</Table.RowItem>

      <Tooltip
        placement="bottom-start"
        disableHoverListener={truncate(event.karta) === `${event.karta}`}
        title={event.karta}
      >
        <Table.RowItem>{truncate(event.karta)}</Table.RowItem>
      </Tooltip>

      <Table.RowItem>
        <Styled.Bold>
          {event.kategoria ? formatMessage({ id: EventCategoryDescriptionEnum[event.kategoria] }) : ''}
        </Styled.Bold>
      </Table.RowItem>

      {displayFullTable && (
        <Table.RowItem>
          {event.posiadacz && (
            <DoubleTextElipsisWithTooltip
              fullText={ownerFullName}
              firstLineText={event.posiadacz.nazwisko}
              secondLineText={event.posiadacz.imie}
              width={tableWidth}
            />
          )}
        </Table.RowItem>
      )}

      <Table.RowItem>
        <Styled.Bold>{formatMessage({ id: EventModDescriptionEnum[event.mod] })}</Styled.Bold>
      </Table.RowItem>

      <Table.RowItem>
        <Styled.Bold>{event.tryb}</Styled.Bold>
      </Table.RowItem>

      <Table.RowItem>
        <div>{format(new Date(event.data), DateFormat.DATE)}</div>
        <div>{format(new Date(event.data), DateFormat.TIME)}</div>
      </Table.RowItem>
    </>
  );
};
